<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{'show': mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar = false"
    />
    <div class="todo-app-list">

      <!-- App Searchbar Header -->
      <div class="app-fixed-search d-flex align-items-center">

        <!-- Toggler -->
        <div class="sidebar-toggle d-block d-lg-none ml-1">
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="cursor-pointer"
            @click="mqShallShowLeftSidebar = true"
          />
        </div>

        <!-- Searchbar -->
        <div class="d-flex align-content-center justify-content-between w-100">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon
                icon="SearchIcon"
                class="text-muted"
              />
            </b-input-group-prepend>
            <b-form-input
              :value="searchQuery"
              placeholder="Search task"
              @input="updateRouteQuery"
            />
          </b-input-group>
        </div>

        <!-- Dropdown -->
        <div class="dropdown">
          <b-dropdown
            variant="link"
            no-caret
            toggle-class="p-0 mr-1"
            right
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="resetSortAndNavigate">
              بدون فیلدر
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: $route.name, query: { ...$route.query, sort: 'title-asc' } }">
              عنوان صعودی
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: $route.name, query: { ...$route.query, sort: 'title-desc' } }">
              عنوان نزولی
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: $route.name, query: { ...$route.query, sort: 'asc' } }">
              اولین ایجاد
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: $route.name, query: { ...$route.query, sort: 'desc' } }">
              آخرین ایجاد
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: $route.name, query: { ...$route.query, sort: 'due-date' } }">
              تاریخ انجام
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <!-- Todo List -->

      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="todo-task-list-wrapper list-group scroll-area"
      >
        <b-overlay
          :class="onProgress ? 'mt-3' : ''"
          :show="onProgress"
        >

          <draggable
            v-model="tasks"
            handle=".draggable-task-handle"
            tag="ul"
            class="todo-task-list media-list"
            @end="ondragChange"
          >

            <li
              v-for="task in tasks"
              :key="task.id"
              class="todo-item"
              :class="{ 'completed': task.isCompleted }"
              @click="handleTaskClick(task)"
            >
              <feather-icon
                icon="MoreVerticalIcon"
                class="draggable-task-handle d-inline"
              />
              <div class="todo-title-wrapper">
                <div class="todo-title-area">
                  <div class="title-wrapper">
                    <b-form-checkbox
                      :checked="task.isCompleted"
                      @click.native.stop
                      @change="completeTask(task)"
                    />
                    <feather-icon
                      :id="`invoice-row-${task.id}`"
                      icon="StarIcon"
                      :class="{'text-warning':task.isImportant,'text-muted':!task.isImportant}"
                    />
                    <span class="todo-title">{{ task.title }}
                      <feather-icon
                        v-show="task.attachments.length"
                        :id="`invoice-row-${task.id}`"
                        icon="PaperclipIcon"
                      />
                    </span>
                  </div>
                </div>
                <div class="todo-item-action">
                  <div class="badge-wrapper mr-1">

                    <b-badge
                      pill
                      :variant="task.priority.label"
                      class="text-capitalize"
                    >
                      {{ task.priority.title }}
                    </b-badge>
                    <b-badge
                      v-for="tag in task.tags"
                      :key="tag.id"
                      pill
                      variant="light-info"
                      class="text-capitalize"
                    >
                      {{ tag.name }}
                    </b-badge>
                  </div>
                  <small class="text-nowrap text-muted mr-1">
                    {{ task.createdDate }}
                  </small>

                  <b-avatar
                    size="15"
                    variant="light-secondary"
                  >
                    <feather-icon
                      icon="UserIcon"
                      size="16"
                    />
                  </b-avatar>
                  <span
                    class=""
                  >  {{
                    route.path === '/tasks/sent' ? task.assignee.name : (task.creator ? task.creator.name : '')
                  }}</span>
                </div>
              </div>

            </li>

          </draggable>
        </b-overlay>

        <div
          class="no-results"
          :class="{'show': !tasks.length}"
        >
          <h5>شما هیچ وظیفه ای ندارید</h5>
        </div>
      </vue-perfect-scrollbar>
    </div>

    <!-- Task Handler -->
    <todo-task-handler-sidebar
      v-model="isTaskHandlerSidebarActive"
      :task="task"
      :comments="comments"
      :clear-task-data="clearTaskData"
      :priorities-list="prioritiesList"
      :on-progress="onProgressTask"
      @add-task="addTask"
      @update-task="updateTask"
      @send-comment="sendComment"
      @update-important="updateImportant"
      @complete-task="completeTask"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <todo-left-sidebar
        :task-priorities="prioritiesList"
        :is-task-handler-sidebar-active.sync="isTaskHandlerSidebarActive"
        :class="{'show': mqShallShowLeftSidebar}"
        @close-left-sidebar="mqShallShowLeftSidebar = false"
      />
    </portal>
  </div>
</template>

<script>

import {
  ref, watch, computed, onUnmounted, onMounted,
} from '@vue/composition-api'
import {
  BFormInput, BInputGroup, BInputGroupPrepend, BDropdown, BDropdownItem,
  BFormCheckbox, BBadge, BAvatar, ToastPlugin, BOverlay,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'
import store from '@/store'
import { formatDate, avatarText } from '@core/utils/filter'
import { useRouter } from '@core/utils/utils'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import axios from '@axios'
import CompositionsApiComponents from '@/views/CompositionsApiComponents'
import todoStoreModule from './todoStoreModule'
import TodoTaskHandlerSidebar from './TodoTaskHandlerSidebar.vue'

// some component that inject to vue is defined for composition api like $bvToast
import TodoLeftSidebar from './TodoLeftSidebar.vue'

export default {
  components: {
    BOverlay,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BBadge,
    BAvatar,
    draggable,
    VuePerfectScrollbar,

    // App SFC
    TodoLeftSidebar,
    TodoTaskHandlerSidebar,
  },
  setup() {
    const TODO_APP_STORE_MODULE_NAME = 'todo'

    // Register module
    if (!store.hasModule(TODO_APP_STORE_MODULE_NAME)) store.registerModule(TODO_APP_STORE_MODULE_NAME, todoStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TODO_APP_STORE_MODULE_NAME)) store.unregisterModule(TODO_APP_STORE_MODULE_NAME)
    })

    const {
      showToast,
    } = CompositionsApiComponents()

    const {
      route,
      router,
    } = useRouter()
    const routeSortBy = computed(() => route.value.query.sort)
    const routeQuery = computed(() => route.value.query.q)
    const routeParams = computed(() => route.value.params)
    watch(routeParams, () => {
      // eslint-disable-next-line no-use-before-define
      fetchTasks()
    })

    const tasks = ref([])
    const newList = ref([])
    const onProgressTask = ref(false)
    const onProgress = ref(false)

    const sortOptions = [
      'latest',
      'title-asc',
      'title-desc',
      'assignee',
      'due-date',
    ]
    const sortBy = ref(routeSortBy.value)
    watch(routeSortBy, val => {
      if (sortOptions.includes(val)) {
        sortBy.value = val
      } else {
        sortBy.value = val
      }
    })
    const resetSortAndNavigate = () => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query))

      delete currentRouteQuery.sort

      router.replace({
        name: route.name,
        query: currentRouteQuery,
      })
        .catch(() => {
        })
    }

    const blankTask = {
      id: null,
      title: '',
      dueDate: '',
      description: '',
      assignee: null,
      tags: [],
      isCompleted: false,
      isDeleted: false,
      isImportant: false,
      attachments: [],
      project: null,
    }
    const task = ref(JSON.parse(JSON.stringify(blankTask)))
    const prioritiesList = ref([])
    const comments = ref([])

    const clearTaskData = () => {
      task.value = JSON.parse(JSON.stringify(blankTask))
      comments.value = []
      onProgressTask.value = false
    }

    const addTask = taskFormData => {
      onProgressTask.value = true
      axios.post('tasks', taskFormData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
        .then(({ data }) => {
          if (data.status) {
            if (route.value.path === '/task/sent') {
              tasks.value.unshift(data.task)
            }
            showToast('نامه  با موفقیت ثبت شد', {
              title: 'انجام درخواست',
              variant: 'success',
            })

            isTaskHandlerSidebarActive.value = false
          } else {
            showToast('ثبت نامه  انجام نشد', {
              title: 'حطا',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          showToast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
        .finally(() => {
          onProgressTask.value = false
        })
    }
    const updateTask = taskData => {
      axios.post(`tasks/${taskData.id}`, taskData.data, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
        .then(({ data }) => {
          if (data.status) {
            tasks.value = tasks.value.map(task => {
              if (task.id === data.task.id) {
                return data.task
              }
              return task
            })
            showToast('ویرایش وظیفه  با موفقیت انجام شد', {
              title: 'انجام درخواست',
              variant: 'success',
            })

            isTaskHandlerSidebarActive.value = false
          } else {
            showToast(data.message ?? 'ویرایش وظیفه انجام نشد', {
              title: 'حطا',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          showToast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
        .finally(() => {
          onProgressTask.value = false
        })
    }
    const sendComment = commentData => {
      axios.post(`tasks/${commentData.id}/comments`, commentData.data, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
        .then(({ data }) => {
          if (data.status) {
            showToast('نظر برای وظیفه ارسال شد', {
              title: 'ارسال نظر',
              variant: 'success',
            })
            isTaskHandlerSidebarActive.value = false
          } else {
            showToast(data.message ?? 'ارسال نظر انجام نشد', {
              title: 'حطا',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          showToast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
        .finally(() => {
          onProgressTask.value = false
        })
    }

    const updateImportant = importantData => {
      axios.put(`tasks/${importantData.id}/update-important`)
        .then(({ data }) => {
          if (data.status) {
            // isTaskHandlerSidebarActive.value = false
            tasks.value = tasks.value.map(obj => {
              if (obj.id === data.task.id) {
                return data.task
              }
              return obj
            })
          } else {
            showToast(data.message ?? 'ارسال نظر انجام نشد', {
              title: 'حطا',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          showToast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
    }
    const completeTask = completeData => {
      axios.put(`tasks/${completeData.id}/complete`)
        .then(({ data }) => {
          if (data.status) {
            axios.get('tasks/inbox')
              .then(({ data }) => {
                if (data.status) {
                  store.commit('task/ADD_TASKS_TO_LIST', data.tasks)
                }
              })
              // isTaskHandlerSidebarActive.value = false
            tasks.value = tasks.value.map(obj => {
              if (obj.id === data.task.id) {
                return data.task
              }
              return obj
            })
          } else {
            showToast(data.message ?? 'ارسال نظر انجام نشد', {
              title: 'حطا',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          showToast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    const isTaskHandlerSidebarActive = ref(false)

    // drag

    // Search Query
    const searchQuery = ref(routeQuery.value)
    watch(routeQuery, val => {
      searchQuery.value = val
    })
    // eslint-disable-next-line no-use-before-define
    // watch([searchQuery, sortBy], () => fetchTasks())
    const updateRouteQuery = val => {
      const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query))

      if (val) {
        currentRouteQuery.q = val
      } else {
        delete currentRouteQuery.q
      }

      router.replace({
        name: route.name,
        query: currentRouteQuery,
      })
    }

    const fetchTasks = () => {
      onProgress.value = true
      const path = typeof route.value === 'undefined' ? '/tasks/inbox' : (route.value.path ? route.value.path : '/tasks/inbox')
      axios.get(`${path}`, {
        params: router.currentRoute.query,
      })
        .then(data => {
          tasks.value = data.data.tasks
        })
        .catch(error => {
          showToast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            variant: 'danger',
          })
        })
        .finally(() => {
          onProgress.value = false
        })
    }

    fetchTasks()

    const handleTaskClick = taskData => {
      task.value = taskData
      isTaskHandlerSidebarActive.value = true
      if (taskData.id) {
        axios.get(`tasks/${taskData.id}/comments`)
          .then(({ data }) => {
            comments.value = data.comments
          })
      }
    }

    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const getPriorities = () => {
      axios.get('tasks/priorities')
        .then(({ data }) => {
          if (data.status) {
            prioritiesList.value = data.priorities
          } else {
            showToast('دریافت لیست اولویت ها با خطا مواجه شد', 'حطا', 'danger')
          }
        })
        .catch(error => {
          showToast(error.response.data.message ?? 'مشکلی در انجام عملیات رخ داده است.', {
            title: 'حطا',
            variant: 'danger',
          })
        })
    }

    onMounted(() => {
      getPriorities()
    })
    const ondragChange = evt => {
      if (evt.newIndex !== evt.oldIndex) {
        onProgress.value = true

        const data = {}
        if (evt.newIndex > evt.oldIndex) {
          data.firstTask = tasks.value[evt.newIndex - 1].order
          data.lastTask = tasks.value[evt.newIndex].order
          data.position = 'bottom'
          data.mainTask = tasks.value[evt.newIndex].id

          reorder(data)
        } else {
          data.firstTask = tasks.value[evt.newIndex].order
          data.lastTask = tasks.value[evt.newIndex + 1].order
          data.position = 'top'
          data.mainTask = tasks.value[evt.newIndex].id

          reorder(data)
        }
      }
    }

    const reorder = data => {
      axios.post('tasks/reorder', data)
        .then(() => {
          fetchTasks()
        })
        .catch(() => {
          onProgress.value = false
        })
    }

    return {
      task,
      tasks,
      addTask,
      updateTask,
      sendComment,
      clearTaskData,
      searchQuery,
      fetchTasks,
      perfectScrollbarSettings,
      updateRouteQuery,
      resetSortAndNavigate,
      onProgress,
      // UI
      isTaskHandlerSidebarActive,

      // Click Handler
      handleTaskClick,

      // Filters
      formatDate,
      avatarText,

      // Left Sidebar Responsive
      mqShallShowLeftSidebar,
      showToast,
      getPriorities,
      prioritiesList,
      comments,
      updateImportant,
      completeTask,
      onProgressTask,
      ondragChange,
      newList,
      route,
      // checkMove
    }
  },
}
</script>

<style lang="scss" scoped>
.draggable-task-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: move;

  .todo-task-list .todo-item:hover & {
    visibility: visible;
  }
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
</style>
